module.exports = __webpack_public_path__ + "d2c4620646ae6fda03e8a66e699baacc.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/salesApp/success-tick.gif
// module id = c4cn
// module chunks = 444